import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useInvitedUsers } from 'app/components/invited-users/useInvitedUsers'
import { InvitedUsersShadcnComponent } from 'app/components/invited-users/InvitedUsersShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { useIsOrgUser } from 'app/hooks/useIsOrgUser'
import { useUser } from 'app/utils'

// observer: reads the staff-v2 feature toggle and authStore.user in render; both resolve
// asynchronously / change in place, so the gate needs an observer wrapper (TRK-6020).
const InvitedUsers = observer(function InvitedUsers(): React.ReactElement {
  const me = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()
  const isOrgUser = useIsOrgUser()
  const { invites, handleDelete } = useInvitedUsers()
  const canEditUser = checkPermission([`org:settings:manage-users`, `users:manage`])

  if (!me) return <></>

  if (!staffV2Enabled || !me.workspaceId) {
    return <Navigate to="/settings/users" replace />
  }

  const canManageUsers =
    me.type === `super` || isOrgUser || checkPermission([`org:settings:manage-users`, `users:manage`])
  if (!canManageUsers) {
    return <Navigate to="/settings/users/active" replace />
  }

  return (
    <InvitedUsersShadcnComponent
      invites={invites}
      canManageUsers={canManageUsers}
      canEditUser={canEditUser}
      onDelete={handleDelete}
    />
  )
})

export default InvitedUsers
